import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselRepository } from '@/core/domain/carousel/repositories/carousel.repository';
import { GetCarouselDataUseCase } from '@/core/domain/carousel/usecases/getCarouselData.usecase';
import { CarouselImplRepository } from './carousel-impl.repository';

const GetCarouselDataUseCaseFactory = (
    carouselRepository: CarouselRepository,
) => new GetCarouselDataUseCase(carouselRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetCarouselDataUseCase,
            useFactory: GetCarouselDataUseCaseFactory,
            deps: [CarouselRepository],
        },
        {
            provide: CarouselRepository,
            useClass: CarouselImplRepository,
        },
    ],
})
export class CarouselDataModule {}
